import ExpertProfileModule from './expert-profile.module'

export default ExpertProfileModule
